export const getLandingPageCostStyles = () => ({
  container: {
    width: '100%',
    background: '#F5F5F5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  innerContainer: {
    width: '1180px',
    margin: '60px 0px',
  },
  'innerContainer-xl': {
    width: '980px',
  },
  'innerContainer-l': {
    width: '640px',
  },
  'innerContainer-m': {
    width: '480px',
  },
  'innerContainer-s': {
    width: '360px',
    margin: '30px 0px',
    padding: '0px 16px',
  },
  title: {
    fontSize: '28px',
    lineHeight: '32px',
    fontWeight: '600',
  },
  'title-s': {
    fontSize: '32px',
    lineHeight: '32px',
    fontWeight: '600',
  },
  description: {
    fontSize: '20px',
    lineHeight: '28px',
    marginTop: '10px',
  },
  divider: {
    margin: '26px 0px',
    width: '100%',
  },
  checkItems: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  checkItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  checkItemIcon: {
    marginRight: '12px',
  },
  checkItemText: {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: '600',
  },
});
